import React, { FC, useEffect } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { AppBar, Tabs, Tab, Typography, Box, Grid } from "@material-ui/core";
import { getFixedFlg } from "../../Header/Header";
import TenpoCheckTable, { isApproveDate, isApproveHour, saveTotalImageSizeOnly } from "./TenpoCheckTable";
import TenpoCheckResultGraphs from "./TenpoCheckResultGraphs";
import TenpoCheckResultPrint from "./TenpoCheckResultPrint";
import { getChangeFlg } from "./TenpoCheckTable";
import TenpoCheckDialog from "../TenpoCheckDialog";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

interface LinkTabProps {
  label?: string;
  href?: string;
}

function LinkTab(props: LinkTabProps) {
  return (
    <Tab
      component="a"
      onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
      }}
      {...props}
      style={{
        fontSize: "20px",
      }}
    />
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  graphsPane: {
    height: "70vh",
    overflowY: "auto",
  },
  printPane: {
    height: "70vh",
    display: "flex",
    flexDirection: "column",
    // iPad縦
    "@media (min-width: 830px)": {
      height: "85vh",
    },
    // iPad横
    "@media (min-width: 1100px)": {
      height: "80vh",
    },
    // GWPC
    "@media (min-width: 1300px)": {
      height: "82vh",
    },
  },
}));

const TenpoCheckTab: FC<{
  tenpoCode: string;
  tenpoCheckId: string;
  lastTenpoCheckId: string;
  setUpdateFlg: any;
  tenpoName?: string;
}> = ({ tenpoCode, tenpoCheckId, lastTenpoCheckId, setUpdateFlg , tenpoName}) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [dialogMessage, setDialogMessage] = React.useState<any[]>([]);
  const [dialogFlg, setDialogFlg] = React.useState(false);

  const dialogClose = () => {
    setDialogFlg(false);
  };

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    if (getChangeFlg()) {
      setDialogMessage(["保存されていません。保存ボタンを押してください。"]); //旧承認日
      setDialogFlg(true);
      return;
    }
    if (newValue === 2) {
      saveTotalImageSizeOnly(tenpoCheckId);
    }
    if (!getChangeFlg() && newValue !== 0) {
      if (!getFixedFlg() && isApproveDate() === 0) {
        setDialogMessage(["作成日に前回作成日以降の日付を入力してください"]); //旧承認日
        setDialogFlg(true);
        return;
      }
      if (!getFixedFlg() && isApproveDate() === -1) {
        setDialogMessage(["作成日に正しい日付を入力してください"]); //旧承認日
        setDialogFlg(true);
        return;
      }
      if (!getFixedFlg() && isApproveHour() === -1) {
        setDialogMessage(["作成時間を入力してください"]);
        setDialogFlg(true);
        return;
      }
    }
    setValue(newValue);
  };

  // 店番変更時のタブリセット
  useEffect(() => {
    setValue(0);
  }, [tenpoCode]);

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          variant="fullWidth"
          value={value}
          onChange={handleChange}
          TabIndicatorProps={{
            style: {
              backgroundColor: "#37ab9d",
              height: "10px",
            },
          }}
          style={{
            backgroundColor: "#f2f2f2",
            color: "#3e3e3e",
          }}
        >
          <LinkTab label="チェック" href="/check" {...a11yProps(0)} />
          <LinkTab label="集計" href="/summery" {...a11yProps(1)} />
          <LinkTab label="提出（印刷）" href="/print" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <TenpoCheckTable
          tenpoCode={tenpoCode}
          tenpoCheckId={tenpoCheckId}
          lastTenpoCheckId={lastTenpoCheckId}
          tenpoName={tenpoName}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Grid container justify="center" className={classes.graphsPane}>
          <TenpoCheckResultGraphs
            tenpoCode={tenpoCode}
            tenpoCheckId={tenpoCheckId}
            lastTenpoCheckId={lastTenpoCheckId}
          />
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Box className={classes.printPane}>
          <TenpoCheckResultPrint
            tenpoCode={tenpoCode}
            tenpoCheckId={tenpoCheckId}
            lastTenpoCheckId={lastTenpoCheckId}
            setUpdateFlg={setUpdateFlg}
            tenpoName={tenpoName}
          />
        </Box>
      </TabPanel>

{/* ダイアログ */}
<TenpoCheckDialog
      msg={dialogMessage}
      isOpen={dialogFlg}
      doOK={dialogClose}
      doNo={dialogClose}
      isAlert={true}
  />
    </div>
  );
};
export default TenpoCheckTab;
